import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

export interface ScheduledClassResource {
    resource_type: "booklet" | "video" | "content";
    booklet_ids: (number | string)[];
    video_ids: (number | string)[];
    content_ids: (number | string)[];
}

export interface CreateScheduledClassInput {
    id?: number;
    class_title: string;
    from_time: string;
    to_time: string;
    tutor_id: number;
    participants: (number | any)[];
    subject_id?: number;
    question_type_id?: number;
    course_id?: string | number;
    meeting_link?: string;
    description?: string;
    meeting_platform?: string;
    is_recurring?: boolean;
    recurrence_frequency?: string;
    recurrence_count?: number;
    recurrence_interval?: number;
    timezone_str?: string;
    sample_booklets?: (number | File)[];
    worksheets?: (number | File)[];
    scheduled_class_resources?: ScheduledClassResource[];
    is_delete?: boolean;
}


export interface CreateScheduledClassParams {
    class_data: CreateScheduledClassInput;
    worksheets?: File[];
    sample_booklet_files?: File[];
}

const initialState: IReduxState<any> = {
    data: {
        status: false,
        message: "",
        data: null
    },
    isLoading: false,
    error: null
} as IReduxState<any>;

export const CreateScheduledClassSlice = createSlice({
    name: "CreateScheduledClassSlice",
    initialState,
    reducers: {
        createScheduledClass: (state, _action: PayloadAction<CreateScheduledClassParams>) => {
            state.isLoading = true;
            state.error = null;
        },
        successCreateScheduledClass: (state, action: PayloadAction<IAPIResponse<any>>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureCreateScheduledClass: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        resetCreateScheduledClass: (state) => {
            state.isLoading = false;
            state.data = initialState.data;
            state.error = null;
        }
    },
});

export const {
    createScheduledClass,
    successCreateScheduledClass,
    failureCreateScheduledClass,
    resetCreateScheduledClass,
} = CreateScheduledClassSlice.actions;

export default CreateScheduledClassSlice.reducer;
